module.exports = {"menu":{"site":"สถานที่","userGroup":"กลุ่มผู้ใช้","user":"ผู้ใช้งาน"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/menu.json
// module id = 117
// module chunks = 35